import createVueApp from '@phoenix/createVueApp';
import { PhxDatographUpDown } from '@phx-styleguides/als';

document.querySelectorAll('.phoenix-datograph-up-down-simulator').forEach((el) => {
  const app = createVueApp();
  app.component('PhxDatographUpDown', PhxDatographUpDown);
  app.mount(el);
});
